import { useState } from 'react';
import { useEffectOnce } from 'react-use';

import { type Language, getLanguageName } from '@/lib/utils/language';

export const useLanguageNames = (
  languages: Language[],
  targetLanguage: Language
) => {
  const [languageNames, setLanguageNames] =
    useState<Record<Language, string>>();

  useEffectOnce(() => {
    const languageMap = Object.fromEntries(
      languages.map((language) => [
        language,
        getLanguageName(language, targetLanguage),
      ])
    ) as Record<Language, string>;
    setLanguageNames(languageMap);
  });

  return languageNames;
};
